import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/shows';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-sm border-b border-background-200/70">
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer group"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-movie-2-line text-lg text-white"></i>
            </div>
            <span className="text-xl font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">
              天天影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`whitespace-nowrap px-3 py-2 text-sm rounded-md transition-colors cursor-pointer ${
                isActive('/')
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories
              .filter((c) => c.slug !== 'all')
              .slice(0, 6)
              .map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`whitespace-nowrap px-3 py-2 text-sm rounded-md transition-colors cursor-pointer ${
                    isActive(`/category/${cat.slug}`)
                      ? 'text-primary-500 bg-primary-50 font-medium'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            <Link
              to="/about"
              className={`whitespace-nowrap px-3 py-2 text-sm rounded-md transition-colors cursor-pointer ${
                isActive('/about')
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-2">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索综艺..."
                className="w-48 pl-9 pr-3 py-2 text-sm bg-background-100 border border-background-200/70 rounded-full text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 cursor-pointer transition-colors"
            aria-label="菜单"
          >
            <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/70 py-3 space-y-1">
            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className={`block px-4 py-2.5 text-sm rounded-lg cursor-pointer transition-colors ${
                isActive('/')
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <i className="ri-home-4-line mr-2"></i>首页
            </Link>
            {categories
              .filter((c) => c.slug !== 'all')
              .map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  onClick={() => setMobileOpen(false)}
                  className={`block px-4 py-2.5 text-sm rounded-lg cursor-pointer transition-colors ${
                    isActive(`/category/${cat.slug}`)
                      ? 'text-primary-500 bg-primary-50 font-medium'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  <i className={`${cat.icon} mr-2`}></i>
                  {cat.name}
                </Link>
              ))}
            <Link
              to="/about"
              onClick={() => setMobileOpen(false)}
              className={`block px-4 py-2.5 text-sm rounded-lg cursor-pointer transition-colors ${
                isActive('/about')
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <i className="ri-information-line mr-2"></i>关于我们
            </Link>
            <div className="px-4 pt-2">
              <input
                type="text"
                placeholder="搜索综艺..."
                className="w-full pl-9 pr-3 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-full text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
              />
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}